import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Kanit-normal.js";
// import { Canvg } from 'canvg';

import headerImage from "../../public/images/attendance-report/attendance-report-header.png";
import examHeaderImage from "../../public/images/attendance-report/exam-report-header.png";

export default {
  methods: {
    async generateTguruPdf() {
      try {
        this.localBtnDisabled = true;
        await this.getMember();
        let pdf = new jsPDF(this.pdfOption);

        // const pdf_width = pdf.internal.pageSize.width;
        const pdf_height = pdf.internal.pageSize.height;

        const margin_l = 30;
        const margin_t = this.pdfConfig.margin.t;

        // const cellWidth = 90;

        const addNewPageIfNeeded = (incrementValue) => {
          if ((pdf_position_y + incrementValue) >= pdf_height - margin_t) {
            pdf.addPage();
            pdf_position_y = margin_t; // Reset the position to the top of the new page
          } else {
            pdf_position_y += incrementValue; // Add the input value
          }
        };

        let pdf_position_y = 0;

        pdf.addFileToVFS("Kanit-Regular.ttf", fontBold);
        pdf.addFont("Kanit-Regular.ttf", "Kanit", "bold");
        pdf.addFileToVFS("Kanit-Regular.ttf", font);
        pdf.addFont("Kanit-Regular.ttf", "Kanit", "normal");

        this.addHeader(pdf, headerImage);
        await this.generateChart();

        const pageWidth = pdf.internal.pageSize.getWidth();
        const headerHeight = 80;
        const startY = headerHeight;

        // --- START: Add Background Color Block ---
        const bgColorR = 240;
        const bgColorG = 245;
        const bgColorB = 250;
        const bgHeight = 200;

        pdf.setFillColor(bgColorR, bgColorG, bgColorB);

        // Draw a filled rectangle (x, y, width, height, style)
        // x=0, y=startY (just below the header), full width, specified height, 'F' for Fill
        pdf.rect(
          0,
          startY,
          pageWidth,
          bgHeight,
          'F' // 'F' stands for Fill
        );
        // --- END: Add Background Color Block ---

        pdf_position_y += margin_t;

        addNewPageIfNeeded(70);

        pdf.setFont("Kanit", "bold");
        pdf.setFontSize(20);
        pdf.setTextColor(28, 34, 79);

        this.thaitext(
          pdf,
          "ชื่อผู้เรียน : " + this.data.firstName + " " + this.data.lastName,
          margin_l,
          pdf_position_y
        );
        addNewPageIfNeeded(this.pdfConfig.endNormal);

        pdf.setFont("Kanit", "normal");
        pdf.setFontSize(this.pdfConfig.typo.small);

        pdf.text(
          "อีเมล : " + this.data.email,
          margin_l,
          pdf_position_y,
          null,
          null,
          "left"
        );
        addNewPageIfNeeded(this.pdfConfig.endNormal)

        const contentMargin = 30;
        const lineY = 147; // Start the line 5mm below the text baseline
        const lineWidth = 1;   // Line thickness in mm
        const lineColor = [28, 34, 79]; // Medium gray color (RGB)

        // Set the line color and thickness
        pdf.setDrawColor(lineColor[0], lineColor[1], lineColor[2]);
        pdf.setLineWidth(lineWidth);

        // Draw the line: pdf.line(x1, y1, x2, y2)
        // Starts at the left margin, ends at the right margin
        pdf.line(
          contentMargin,
          lineY,
          pageWidth - contentMargin,
          lineY
        );
        addNewPageIfNeeded(this.pdfConfig.endNormal)

        this.thaitext(
          pdf,
          "ชื่อคอร์ส : " + this.data.courseName,
          margin_l,
          pdf_position_y
        );
        addNewPageIfNeeded(this.pdfConfig.endNormal);

        pdf.text(
          "ประเภทคอร์ส : " + this.courseOnlineType,
          margin_l,
          pdf_position_y,
          null,
          null,
          "left"
        );
        addNewPageIfNeeded(this.pdfConfig.endNormal);

        pdf.text(
          "รหัสคอร์สเรียน : " + (this.data.courseCode !== null ? this.data.courseCode : ""),
          margin_l,
          pdf_position_y,
          null,
          null,
          "left"
        );
        addNewPageIfNeeded(this.pdfConfig.endNormal);

        this.thaitext(
          pdf,
          "วันที่สมัครเรียน : " + this.formatDateToThai(this.data.courseEnrollStartDate),
          margin_l,
          pdf_position_y
        );
        addNewPageIfNeeded(this.pdfConfig.endNormal);

        this.thaitext(
          pdf,
          "ข้อมูลวันที่ : " + this.formatThaiMonthRange(this.start, this.end),
          margin_l,
          pdf_position_y
        );
        addNewPageIfNeeded(this.pdfConfig.endNormal);

        // attendance summary
        const attendanceSummaryData = [
          {
            label: "เข้าเรียน\n\nOnsite",
            value: this.countPresent(),
            bgColor: [230, 250, 230], // Light green
            valueColor: [212, 232, 191] // Dark green
          },
          {
            label: "เข้าเรียน\n\nZoom",
            value: this.countPresentZoom(),
            bgColor: [230, 245, 255], // Light blue
            valueColor: [192, 231, 245] // Dark blue
          },
          {
            label: "มาสาย\n\nOnsite",
            value: this.countLate(),
            bgColor: [255, 240, 230], // Light orange
            valueColor: [255, 218, 193] // Dark orange
          },
          {
            label: "มาสาย\n\nZoom",
            value: this.countLateZoom(),
            bgColor: [255, 245, 230], // Light yellow
            valueColor: [249, 230, 179] // Dark yellow
          },
          {
            label: "ขาดเรียน",
            value: this.countAbsent(),
            bgColor: [255, 230, 235], // Light pink
            valueColor: [250, 200, 212] // Dark pink
          },
          {
            label: "ลา",
            value: this.countLeave(),
            bgColor: [240, 235, 255], // Light purple
            valueColor: [189, 184, 220] // Dark purple
          }
        ];

        // --- Section Title: สรุปการเข้าเรียน ---
        addNewPageIfNeeded(this.pdfConfig.endNormal)

        const sectionTitleFontSize = 12;
        let cellHeight = 26;

        pdf.setFont("Kanit", "bold");
        pdf.setTextColor(30, 30, 90); // Dark blue for titles
        pdf.setFontSize(sectionTitleFontSize);
        // pdf.text("สรุปการเข้าเรียน", contentMargin, pdf_position_y);
        pdf_position_y += this.pdfConfig.margin.bHeaderTable;

        pdf.setLineWidth(0.5);
        pdf.setFillColor(240, 245, 250);
        pdf.setDrawColor(220, 227, 243);
        pdf.rect(contentMargin, pdf_position_y, pageWidth - (contentMargin * 2), cellHeight, 'FD');
        // addNewPageIfNeeded(this.pdfConfig.endRow);
        this.thaitext(
          pdf,
          'สรุปการเข้าเรียน',
          margin_l + 5, pdf_position_y + 16
        );
        pdf_position_y += sectionTitleFontSize * 0.3528 + 8; // Move Y down, adding some padding

        addNewPageIfNeeded(sectionTitleFontSize + 2);

        // --- Attendance Cards Layout ---
        const cardWidth = 58; // Adjusted width for better fit (was 60mm)
        const cardHeight = 80; // Adjusted height for better fit (was 80mm)
        const cardSpacing = 5;
        const borderRadius = 10; // Adjusted radius for smaller cards

        // Recalculate dimensions based on adjusted card width
        const totalCardsWidth = (attendanceSummaryData.length * cardWidth) +
          ((attendanceSummaryData.length - 1) * cardSpacing);

        // Calculate starting X to center the block of cards
        // Use margin_l and pageWidth-margin_l for the bounding box
        const startX = margin_l + ((pageWidth - (margin_l * 2) - totalCardsWidth) / 2);

        let cardX = startX;

        pdf.setLineWidth(0.5);
        pdf.setDrawColor(220, 227, 243);
        pdf.rect(contentMargin, pdf_position_y, pageWidth - (contentMargin * 2), 105);
        addNewPageIfNeeded(12);

        // Helper function to draw a single attendance card
        const drawAttendanceCard = (pdf, data, x, y) => {
          // Card background
          pdf.setFillColor(data.bgColor[0], data.bgColor[1], data.bgColor[2]);
          pdf.setDrawColor(data.valueColor[0], data.valueColor[1], data.valueColor[2]);
          pdf.roundedRect(x, y, cardWidth, cardHeight, borderRadius, borderRadius, 'FD');

          // --- Top Label Text (Centered) ---
          pdf.setFont("Kanit", "normal");
          pdf.setFontSize(12); // Smaller font for label
          // pdf.setTextColor(0, 0, 0);

          const labelLines = data.label.split('\n');
          let labelY = y + 15;

          for (const line of labelLines) {
            // Corrected Centering Logic: x + (cardWidth / 2)
            pdf.text(line, x + cardWidth / 2, labelY, { align: 'center' });
            labelY += 5; // Tighter line spacing for smaller card
          }

          // --- Value (Centered) ---
          pdf.setFont("Kanit", "bold");
          pdf.setFontSize(26); // Smaller font for smaller card
          // pdf.setTextColor(data.valueColor[0], data.valueColor[1], data.valueColor[2]);

          const valueText = String(data.value);
          // Use pdf.text with align: 'center' and the center X coordinate
          pdf.text(valueText, x + cardWidth / 2, y + cardHeight / 2 + 10, { align: 'center' });

          // --- "จาก X ครั้ง" (Centered) ---
          pdf.setFont("Kanit", "normal");
          pdf.setFontSize(10); // Smallest font
          // pdf.setTextColor(100, 100, 100);

          const totalText = `จาก ${this.totalCount()} ครั้ง`;
          this.thaitext(pdf, totalText, x + (cardWidth - 5) / 4, y + cardHeight - 10);
        };

        // Loop through the data and draw each card
        for (let i = 0; i < attendanceSummaryData.length; i++) {
          const cardData = attendanceSummaryData[i];
          drawAttendanceCard(pdf, cardData, cardX, pdf_position_y);
          cardX += cardWidth + cardSpacing; // Move X for the next card
        }

        pdf_position_y += cardHeight + 10; // Move pdf_position_y down past the cards for next section

        addNewPageIfNeeded(this.pdfConfig.endNormal);

        // -- table 1 --
        const colWidths = [
          122, // Col 1: วันที่
          122, // Col 2: เรียนสด
          122  // Col 3: เรียน Zoom
        ];
        const tableX = contentMargin; // Start X position of the table

        // --- Colors ---
        const COLOR_HEADER = [30, 45, 90];        // Dark Blue
        const COLOR_TOTAL_TIME = [235, 255, 235]; // Light Green
        const COLOR_ATTENDED = [230, 245, 255];   // Light Blue
        const COLOR_BORDER = [200, 200, 200];     // Light Gray Border

        // --- Section Title ---
        pdf.setFont("Kanit", "bold");
        pdf.setTextColor(30, 30, 90); // Dark blue for titles
        pdf.setFontSize(sectionTitleFontSize);
        pdf_position_y += this.pdfConfig.margin.bHeaderTable;

        pdf.setLineWidth(0.5);
        pdf.setFillColor(240, 245, 250);
        pdf.setDrawColor(220, 227, 243);
        pdf.rect(contentMargin, pdf_position_y, pageWidth - (contentMargin * 2), cellHeight, 'FD');

        this.thaitext(
          pdf,
          "จำนวนชั่วโมงที่เข้าเรียน (ชั่วโมง:นาที)",
          margin_l + 5,
          pdf_position_y + 16
        );

        pdf_position_y += sectionTitleFontSize * 0.3528 + 8;
        addNewPageIfNeeded(sectionTitleFontSize + 2);

        pdf.setLineWidth(0.5);
        pdf.setDrawColor(220, 227, 243);
        pdf.rect(contentMargin, pdf_position_y, pageWidth - (contentMargin * 2), cellHeight * 5);

        addNewPageIfNeeded(12);

        // --- Table Header ---
        const headerText = ["วันที่", "เรียนสด", "เรียน Zoom"];
        let headerX = tableX;
        pdf.setLineWidth(0.1);
        pdf.setDrawColor(COLOR_BORDER[0], COLOR_BORDER[1], COLOR_BORDER[2]);
        pdf.setFont('Kanit', 'bold');
        pdf.setFontSize(10);
        pdf.setTextColor(255, 255, 255); // White text
        cellHeight = 20

        for (let i = 0; i < headerText.length; i++) {
          const width = colWidths[i];

          // 1. Draw Header Cell Background
          pdf.setFillColor(COLOR_HEADER[0], COLOR_HEADER[1], COLOR_HEADER[2]);
          pdf.rect(headerX + 5, pdf_position_y, width, cellHeight, 'F');

          // 2. Center Header Text
          const text = headerText[i];
          const textWidth = pdf.getStringUnitWidth(text) * pdf.getFontSize() / pdf.internal.scaleFactor;
          const textX = headerX + 5 + (width - textWidth) / 2;
          const textY = pdf_position_y + cellHeight / 2 + (pdf.getFontSize() * 0.3528 / 3); // Vertically centered

          this.thaitext(pdf, text, textX, textY);

          headerX += width + 5;
        }
        pdf_position_y += cellHeight + 5;


        pdf.setFont('Kanit', 'normal');
        pdf.setFontSize(10);
        pdf.setTextColor(0, 0, 0); // Black text
        let colX = tableX;

        this.data.classAttendanceStat.forEach((row) => {
          pdf.setFillColor(244, 246, 250);
          pdf.rect(margin_l + 5, pdf_position_y, colWidths[0], cellHeight, 'F');
          this.thaitext(pdf, row.cls_date ? this.formatDateToThaiShort(row.cls_date) : '', (margin_l + 5 + colWidths[0]) / 2, pdf_position_y + 12);
          colX = tableX + colWidths[0];

          let duration;
          duration = !row?.clsa_status?.includes('_ZOOM')
            ? (row.clsa_duration ? this.secondsToHHMM(row.clsa_duration) : '-')
            : '-';
          pdf.setFillColor(COLOR_TOTAL_TIME[0], COLOR_TOTAL_TIME[1], COLOR_TOTAL_TIME[2]);
          pdf.rect(margin_l + 132, pdf_position_y, colWidths[1], cellHeight, 'F');          
          pdf.text(duration, colX + colWidths[1] / 2 + 10, pdf_position_y + 12, { align: "center" });

          colX += colWidths[1];

          let zoomDuration;
          zoomDuration = row?.clsa_status?.includes('_ZOOM')
            ? (row.clsa_duration ? this.secondsToHHMM(row.clsa_duration) : '-')
            : '-';
          pdf.setFillColor(COLOR_ATTENDED[0], COLOR_ATTENDED[1], COLOR_ATTENDED[2]);
          pdf.rect(margin_l + 259, pdf_position_y, colWidths[2], cellHeight, 'F');
          pdf.text(zoomDuration, colX + 5 + colWidths[2] / 2 + 10, pdf_position_y + 12, { align: "center" });

          addNewPageIfNeeded(20);
        });

        if (this.data.classAttendanceStat.length <= 3) {
          pdf.addPage();
          pdf_position_y = 24
        } else {
          pdf_position_y += 20;
        }



        // -- table 2 --
        cellHeight = 26;
        const colWidthsReport = [
          155, // Col 1: เนื้อหาการเรียน
          105, // Col 2: เวลาทั้งหมด
          105  // Col 3: เข้าเรียน
        ];

        pdf.setFont("Kanit", "bold");
        pdf.setTextColor(30, 30, 90); // Dark blue for titles
        pdf.setFontSize(sectionTitleFontSize);
        pdf_position_y += this.pdfConfig.margin.bHeaderTable;

        pdf.setLineWidth(0.5);
        pdf.setFillColor(240, 245, 250);
        pdf.setDrawColor(220, 227, 243);
        pdf.rect(contentMargin, pdf_position_y, pageWidth - (contentMargin * 2), cellHeight, 'FD');

        this.thaitext(
          pdf,
          "รายงานการเรียนเทปย้อนหลัง (ชั่วโมง:นาที)",
          margin_l + 5,
          pdf_position_y + 16
        );

        pdf_position_y += sectionTitleFontSize * 0.3528 + 8;
        addNewPageIfNeeded(sectionTitleFontSize + 2);

        pdf.setLineWidth(0.5);
        pdf.setDrawColor(220, 227, 243);
        pdf.rect(contentMargin, pdf_position_y, pageWidth - (contentMargin * 2), cellHeight * (this.data.LearningSummaryByLecture.length + 2) + 10);

        addNewPageIfNeeded(12);

        // --- Table Header ---
        const headerTextReport = ["เนื้อหาการเรียน", "เวลาทั้งหมด", "เข้าเรียน"];
        let headerXReport = tableX;

        pdf.setLineWidth(0.1);
        pdf.setDrawColor(COLOR_BORDER[0], COLOR_BORDER[1], COLOR_BORDER[2]);
        pdf.setFont('Kanit', 'bold');
        pdf.setFontSize(10);
        pdf.setTextColor(255, 255, 255); // White text
        cellHeight = 20

        for (let i = 0; i < headerTextReport.length; i++) {
          const width = colWidthsReport[i];

          // 1. Draw Header Cell Background
          pdf.setFillColor(COLOR_HEADER[0], COLOR_HEADER[1], COLOR_HEADER[2]);
          pdf.rect(headerXReport + 5, pdf_position_y, width, cellHeight, 'F');

          // 2. Center Header Text
          const text = headerTextReport[i];
          const textWidth = pdf.getStringUnitWidth(text) * pdf.getFontSize() / pdf.internal.scaleFactor;
          const textX = headerXReport + 5 + (width - textWidth) / 2;
          const textY = pdf_position_y + cellHeight / 2 + (pdf.getFontSize() * 0.3528 / 3); // Vertically centered

          this.thaitext(pdf, text, textX, textY);

          headerXReport += width + 5;
        }
        pdf_position_y += cellHeight + 5;


        pdf.setFont('Kanit', 'normal');
        pdf.setFontSize(10);
        pdf.setTextColor(0, 0, 0); // Black text
        let colXReport = tableX;
        let sumLearningTime = 0;
        let sumLectureLengthTime = 0;

        this.data.LearningSummaryByLecture.forEach((row) => {
          sumLearningTime += Number(row.total_learning_time);
          sumLectureLengthTime += Number(row.lecture_length_in_second);
          pdf.setFillColor(244, 246, 250);
          pdf.rect(margin_l + 5, pdf_position_y, colWidthsReport[0], cellHeight, 'F');
          this.thaitext(pdf, row.lec_name, margin_l + 10, pdf_position_y + 12);
          colXReport = tableX + colWidthsReport[0];

          pdf.setFillColor(255, 236, 224);
          pdf.rect(colXReport + 10, pdf_position_y, colWidthsReport[1], cellHeight, 'F');
          this.thaitext(pdf, row.lecture_length_in_second ? this.secondsToHHMM(row.lecture_length_in_second) : '', colXReport + colWidthsReport[1] / 2, pdf_position_y + 12);
          colXReport += colWidthsReport[1];

          pdf.setFillColor(252, 242, 217);
          pdf.rect(colXReport + 15, pdf_position_y, colWidthsReport[2], cellHeight, 'F');
          this.thaitext(pdf, row.total_learning_time ? this.secondsToHHMM(row.total_learning_time) : '', colXReport + 5 + colWidthsReport[2] / 2, pdf_position_y + 12);

          addNewPageIfNeeded(20);
        });

        // --- Table Footer ---
        const footerX = tableX + 5;
        const footerHeight = cellHeight;
        pdf_position_y += 5
        const footerTextY = pdf_position_y + footerHeight / 2 + (pdf.getFontSize() * 0.3528 / 3);
        // --- Col 1: "รวม" Text ---
        pdf.setFont('Kanit', 'bold');
        pdf.setFillColor(215, 220, 237);
        pdf.rect(footerX, pdf_position_y, colWidthsReport[0], footerHeight, 'F');
        pdf.text("รวม", footerX + colWidthsReport[0] / 2, footerTextY + 2, { align: 'center' }); // Centered
        colXReport = footerX + colWidthsReport[0];

        // --- Col 2: Total Time ---
        pdf.setFillColor(255, 161, 98);
        pdf.rect(colXReport + 5, pdf_position_y, colWidthsReport[1], footerHeight, 'F');
        pdf.text(this.secondsToHHMM(sumLectureLengthTime), colXReport + 5 + colWidthsReport[1] / 2, footerTextY + 2, { align: 'center' });
        colXReport += colWidthsReport[1];

        // --- Col 3: Total Attended ---
        pdf.setFillColor(244, 212, 123);
        pdf.rect(colXReport + 10, pdf_position_y, colWidthsReport[2], footerHeight, 'F');
        pdf.text(this.secondsToHHMM(sumLearningTime), colXReport + 10 + colWidthsReport[2] / 2, footerTextY + 2, { align: 'center' });

        pdf_position_y += footerHeight + 10; // Final Y position




        // -- รายงานผลคะแนนสอบ --
        if (this.data.ExamResult.length > 0) {
          addNewPageIfNeeded(this.pdfConfig.endRow);
          pdf.addPage();
          pdf_position_y = 0;

          this.addHeader(pdf, examHeaderImage);
          await this.generateChart();
          pdf_position_y += headerHeight + 15;

          cellHeight = 26;
          pdf.setFont("Kanit", "bold");
          pdf.setTextColor(30, 30, 90); // Dark blue for titles
          pdf.setFontSize(sectionTitleFontSize);
          pdf_position_y += this.pdfConfig.margin.bHeaderTable;

          // create title block
          pdf.setLineWidth(0.5);
          pdf.setFillColor(240, 245, 250);
          pdf.setDrawColor(220, 227, 243);
          pdf.rect(contentMargin, pdf_position_y, pageWidth - (contentMargin * 2), cellHeight, 'FD');
          this.thaitext(
            pdf,
            'รายงานผลคะแนนสอบ',
            margin_l + 5, pdf_position_y + 16
          );
          pdf_position_y += sectionTitleFontSize * 0.3528 + 8;
          addNewPageIfNeeded(sectionTitleFontSize + 2);

          // table border
          pdf.setLineWidth(0.5);
          pdf.setDrawColor(220, 227, 243);
          let addColAmount = this.data.ExamResult.length > 0 ? 2 : 3
          let addMarginBottom = this.data.ExamResult.length > 0 ? 10 : 0
          pdf.rect(contentMargin, pdf_position_y, pageWidth - (contentMargin * 2), cellHeight * (this.data.ExamResult.length + addColAmount) + addMarginBottom);
          addNewPageIfNeeded(12);

          // -- table --
          const examColWidths = [270, 100];
          const examTableX = contentMargin;
          const COLOR_EXAM_NAME = [245, 247, 251];
          const COLOR_EXAM_SCORE = [227, 225, 240];
          const COLOR_FOOT_EXAM_NAME = [217, 225, 241];
          const COLOR_FOOT_EXAM_SCORE = [174, 167, 210];

          // -- table header --
          const examHeaderText = ["ชื่อข้อสอบ", "คะแนน"];
          let examHeaderX = examTableX;
          pdf.setLineWidth(0.1);
          pdf.setDrawColor(COLOR_BORDER[0], COLOR_BORDER[1], COLOR_BORDER[2]);
          pdf.setFont('Kanit', 'bold');
          pdf.setFontSize(10);
          pdf.setTextColor(255, 255, 255); // White text
          cellHeight = 20

          for (let i = 0; i < examHeaderText.length; i++) {
            const width = examColWidths[i];

            // 1. Draw Header Cell Background
            pdf.setFillColor(COLOR_HEADER[0], COLOR_HEADER[1], COLOR_HEADER[2]);
            pdf.rect(examHeaderX + 5, pdf_position_y, width, cellHeight, 'F');

            // 2. Center Header Text
            const text = examHeaderText[i];
            const textWidth = pdf.getStringUnitWidth(text) * pdf.getFontSize() / pdf.internal.scaleFactor;
            const textX = examHeaderX + 5 + (width - textWidth) / 2;
            const textY = pdf_position_y + cellHeight / 2 + (pdf.getFontSize() * 0.3528 / 3); // Vertically centered

            // Use thaitext or pdf.text
            this.thaitext(pdf, text, textX, textY);
            examHeaderX += width + 5;
          }

          pdf_position_y += cellHeight + 5;

          pdf.setFont('Kanit', 'normal');
          pdf.setFontSize(10);
          pdf.setTextColor(0, 0, 0); // Black text
          let examColX = examTableX;

          this.data.ExamResult.forEach((row) => {
            pdf.setFillColor(COLOR_EXAM_NAME[0], COLOR_EXAM_NAME[1], COLOR_EXAM_NAME[2]);
            pdf.rect(margin_l + 5, pdf_position_y, examColWidths[0], cellHeight, 'F');
            this.thaitext(pdf, row.lec_name ?? '', margin_l + 10, pdf_position_y + 12);
            examColX = examTableX + examColWidths[0];

            pdf.setFillColor(COLOR_EXAM_SCORE[0], COLOR_EXAM_SCORE[1], COLOR_EXAM_SCORE[2]);
            pdf.rect(margin_l + 280, pdf_position_y, examColWidths[1], cellHeight, 'F');
            this.thaitext(pdf, row.lel_examResultPercent ?? '', examColX + examColWidths[1] / 2, pdf_position_y + 12);

            addNewPageIfNeeded(20);
          });

          // --- Table Footer ---
          const examFooterX = examTableX + 5;
          const examFooterHeight = cellHeight;
          const footerTextWidth = pdf.getStringUnitWidth("คะแนนเฉลี่ย") * pdf.getFontSize() / pdf.internal.scaleFactor;
          const footerTextX = examTableX + 5 + (examColWidths[0] - footerTextWidth) / 2;
          pdf_position_y += 5
          const examFooterTextY = pdf_position_y + examFooterHeight / 2 + (pdf.getFontSize() * 0.3528 / 3);
          // --- Col 1: "คะแนนเฉลี่ย" Text ---
          pdf.setFont('Kanit', 'bold');
          pdf.setFillColor(COLOR_FOOT_EXAM_NAME[0], COLOR_FOOT_EXAM_NAME[1], COLOR_FOOT_EXAM_NAME[2]);
          pdf.rect(examFooterX, pdf_position_y, examColWidths[0], examFooterHeight, 'F');
          this.thaitext(pdf, "คะแนนเฉลี่ย", footerTextX, examFooterTextY + 2);
          colXReport = examFooterX + examColWidths[0];

          // --- Col 2 ---
          pdf.setFillColor(COLOR_FOOT_EXAM_SCORE[0], COLOR_FOOT_EXAM_SCORE[1], COLOR_FOOT_EXAM_SCORE[2]);
          pdf.rect(colXReport + 5, pdf_position_y, examColWidths[1], examFooterHeight, 'F');
          pdf.text(this.data.AverageExamResultPercent[0].average_percent ?? '', colXReport + 5 + examColWidths[1] / 2, examFooterTextY + 2, { align: 'center' });
          colXReport += examColWidths[1];

          pdf_position_y += examFooterHeight + 20; // Final Y position




          // -- title block --
          addNewPageIfNeeded(20);
          cellHeight = 26;
          pdf.setFont("Kanit", "bold");
          pdf.setTextColor(30, 30, 90); // Dark blue for titles
          pdf.setFontSize(sectionTitleFontSize);

          pdf.setLineWidth(0.5);
          pdf.setFillColor(240, 245, 250);
          pdf.setDrawColor(220, 227, 243);
          pdf.rect(contentMargin, pdf_position_y, pageWidth - (contentMargin * 2), cellHeight, 'FD');
          this.thaitext(
            pdf,
            'รายงานผลคะแนนสอบ',
            margin_l + 5, pdf_position_y + 16
          );
          pdf_position_y += sectionTitleFontSize * 0.3528 + 8;
          addNewPageIfNeeded(sectionTitleFontSize + 2);

          // -- chart border --
          pdf.setLineWidth(0.5);
          pdf.setDrawColor(220, 227, 243);
          pdf.rect(contentMargin, pdf_position_y, pageWidth - (contentMargin * 2), cellHeight * (this.data.ExamResult.length + 2));

          const barChartColor = [
            [236, 126, 145], // Red/Pink
            [253, 207, 218], // Light Pink
            [116, 192, 230], // Blue
            [173, 216, 230], // Light Blue
            [144, 198, 59],  // Green
            [197, 232, 169]  // Light Green
          ];

          // --- Dimensions (in mm) ---
          const chartAreaWidth = pageWidth - ((margin_l + 5) * 2);
          const chartXStart = margin_l + 5;

          const labelWidth = 140;
          const barWidthMax = chartAreaWidth - labelWidth - 10;
          const barHeight = 18;
          const barSpacing = 8;
          const barRadius = 4;

          const chartMaxScale = 100;

          pdf_position_y += 16 * 0.3528 + 8;

          pdf.setFont('Kanit', 'normal');
          pdf.setFontSize(12);
          pdf.setTextColor(100, 100, 100);
          const axisY = pdf_position_y + (this.data.ExamResult.length * (barHeight + barSpacing));

          for (let val = 0; val <= chartMaxScale; val += 20) {
            pdf.text(String(val), chartXStart + labelWidth + 5 + (val / chartMaxScale) * (barWidthMax - 15), axisY + 20, { align: 'left' });
          }

          pdf_position_y += 5;

          // --- Draw Bars ---
          for (const [index, data] of this.data.ExamResult.entries()) {
            const barLength = (Number(data.lel_examResultPercent) / chartMaxScale) * barWidthMax;

            // label
            pdf.setFont('Kanit', 'normal');
            pdf.setFontSize(10);
            pdf.setTextColor(0, 0, 0);

            const textY = pdf_position_y + barHeight / 2 + (pdf.getFontSize() * 0.3528 / 3);
            // pdf.text(data.lec_name, chartXStart + 2, textY, { align: 'left' });
            this.thaitext(pdf, data.lec_name, chartXStart + 2, textY);


            // bar
            pdf.setFillColor(...barChartColor[index]);
            pdf.setDrawColor(...barChartColor[index]);

            const barX = chartXStart + labelWidth + 5;

            pdf.roundedRect(
              barX,
              pdf_position_y,
              barLength,
              barHeight,
              barRadius,
              barRadius,
              'F'
            );

            pdf_position_y += barHeight + barSpacing;
          }

          pdf_position_y = axisY + 10;
        }

        setTimeout(() => {
          pdf.save("รายงานการเข้าเรียน.pdf");
        }, 0);
        this.localBtnDisabled = false;
      } catch (err) {
        console.log(err);
      }
    },

    addHeader(pdf, bgDataUrl) {
      // Get page dimensions (assuming 'mm' unit from default or this.pdfOption)
      const pageWidth = pdf.internal.pageSize.getWidth();

      // Define header dimensions (in mm)
      const headerHeight = 80; // mm
      const margin = 10; // mm from the edge

      // --- 2.1. Background Image (bg.png - converted from bg.svg) ---
      // NOTE: Using 'PNG' format
      pdf.addImage(
        bgDataUrl,
        'PNG',
        0,     // X: 0 
        0,     // Y: 0
        pageWidth, // Width: full page width
        headerHeight // Height: fixed header height
      );

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.setLineWidth(0.2);
      pdf.line(margin, headerHeight, pageWidth - margin, headerHeight);
    },
  }
}